import DarkModeOutlined from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlined from "@mui/icons-material/LightModeOutlined";
import { IconButton, Tooltip } from "@mui/material";
import { useColorScheme } from "@mui/material/styles";

import { useLabel } from "@mr-portfolio-infrastructure/translations/use-label";

export function ThemeModeToggle(): React.JSX.Element {
  const getLabel = useLabel();
  const { mode, systemMode, setMode } = useColorScheme();
  const activeMode = mode === "system" ? systemMode : mode;
  const isDarkMode = activeMode === "dark";
  const toggleLabel = getLabel(isDarkMode ? "theme.switchToLight" : "theme.switchToDark");

  return (
    <Tooltip title={toggleLabel}>
      <IconButton aria-label={toggleLabel} onClick={() => setMode(isDarkMode ? "light" : "dark")}>
        {isDarkMode ? <LightModeOutlined /> : <DarkModeOutlined />}
      </IconButton>
    </Tooltip>
  );
}
